import { formatHours } from 'utils/dayjs';

import { FormattedDate } from '@atoms/FormattedDate/FormattedDate';

type Props = {
  value: string;
  format?: 'utc' | 'cet';
};

/**
 * Formatted date and time presentation element
 * @value string Serialized ISO DateTime value
 * @returns A rendered element presenting the date and time
 */
export const FormattedDateTime = ({ value, format = 'utc' }: Props) => {
  if (!value) {
    return <p>Not available</p>;
  }
  const utcString = new Date(value)?.toUTCString();

  return (
    <time dateTime={value} title={utcString || value}>
      <FormattedDate value={value} />
      <div className="text-base font-medium">{formatHours(value, format)}</div>
    </time>
  );
};
